import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

import AddControl from 'components/add_control/v2';

export const Header = ({ addStep, workflow }) => {
  if (!workflow || workflow.steps.length === 0) {
    return null;
  }
  return (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <h5>Voucher Approval Workflow</h5>
      <AddControl label="Add Step" onClick={addStep} />
    </div>
  );
};

Header.propTypes = {
  addStep: PropTypes.func.isRequired,
  workflow: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

const mapStateToProps = state => ({
  workflow: state.workflow
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);

